export default function calculateDaysUntilExpired(
  expirationDate: string | null
): number {
  if (!expirationDate || isNaN(Date.parse(expirationDate))) return 0;

  const targetDate = new Date(expirationDate);
  const dateNow = new Date();

  // If the expiration date is in the past, return 0
  if (dateNow > targetDate) return 0;

  const todayStart = new Date().setHours(0, 0, 0, 0);
  const millisecondsInADay = 1000 * 60 * 60 * 24;

  const daysToExpired = Math.floor(
    (targetDate.getTime() - todayStart) / millisecondsInADay
  );

  return Math.max(daysToExpired, 1);
}
